var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.canVote)?_c('div',{staticClass:"cta-button"},[_c('a',{attrs:{"href":_vm.voteLink,"target":"_blank"},on:{"click":_vm.onVote}},[_vm._v("Vote now "),_c('i',{staticClass:"fa fa-long-arrow-right",attrs:{"aria-hidden":"true"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c34ba512","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoteNow.vue
// module id = null
// module chunks = 